import { createContext, Dispatch, SetStateAction } from 'react';
import { OverlayRef } from 'ncoded-component-library/build/components/atoms/Overlay/Overlay.component';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import utils from 'utils';

type DataRoomDocumentsContextValues = {
  baseDocsPath: string;
  areDocsLoading: boolean;
  documentRoute: Array<DataRoomNode>;
  currentlyDisplayedNodes: Array<DataRoomNode>;
  baseLevelNodes?: Array<DataRoomNode>;
  canChangeView: boolean;
  buySidePreviewMember: DataRoomMember;
  addAFolderModal: OverlayRef;
  areInsightsShown: boolean;
  canTagFiles: boolean;
  isDataRoomEmpty: boolean;
  closeDiscoveringFeature: () => void;
  setCurrentlySelectedFolder: (node: DataRoomNode | null) => void;
  setCurrentlyDisplayedNodes: Dispatch<SetStateAction<DataRoomNode[]>>;
  sortCurrentlyDisplayedNodes: () => void;
  updateBuySidePreviewMember: (value: DataRoomMember) => void;
  updateNodeById: (nodeId: string, newValue: DataRoomNode) => void;
};

export default createContext<DataRoomDocumentsContextValues>({
  baseDocsPath: '',
  areDocsLoading: false,
  documentRoute: [],
  currentlyDisplayedNodes: [],
  baseLevelNodes: [],
  canChangeView: false,
  buySidePreviewMember: null,
  addAFolderModal: null,
  areInsightsShown: true,
  canTagFiles: false,
  isDataRoomEmpty: false,
  closeDiscoveringFeature: utils.noop,
  setCurrentlySelectedFolder: utils.noop,
  setCurrentlyDisplayedNodes: utils.noop,
  sortCurrentlyDisplayedNodes: utils.noop,
  updateBuySidePreviewMember: utils.noop,
  updateNodeById: utils.noop,
});
